export default __webpack_public_path__ + "static/media/16.5d68f75e.mp3";